import { render, staticRenderFns } from "./LeadDuplicatesModal.vue?vue&type=template&id=29291601"
import script from "./LeadDuplicatesModal.vue?vue&type=script&lang=js"
export * from "./LeadDuplicatesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports